import React from 'react';
import { LogisticsObjectDetailPage } from '@/components/common/LogisticsObjectDetailPage';

const ConsignmentDetailPage: React.FC = () => {
  return (
    <LogisticsObjectDetailPage
      config={{
        logisticsObjectType: 'consignment',
        routeParamKey: 'consignmentId',
        pageTitle: 'Consignment Details',
        backRoute: '/consignments',
        backLabel: 'Back to Consignments',
        tabIdPrefix: 'consignment',
        tabsAriaLabel: 'consignment detail tabs',
        missingIdMessage: 'No consignment ID provided in the URL.',
        noDataMessage: 'No consignment data available. The consignment might not exist or you may not have permission to view it.',
      }}
    />
  );
};

export default ConsignmentDetailPage;